import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border-2 border-black px-2.5 py-0.5 text-xs font-sans font-semibold transition-colors focus:outline-none",
  {
    variants: {
      variant: {
        default:
          "bg-[#ffd703] text-black",
        secondary:
          "bg-[#c7dfe9] text-black",
        destructive:
          "bg-red-500 text-white",
        outline: "bg-[#fef9e7] text-black",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
